<template>
  <step-section
    :title="$t('safety')"
    :loading="loading$"
    :step-number="getStepNumber('safety')"
  >
    <div class="row row--custom">
      <div
        class="col-6 col-xs-4 col-sm-4--custom col-small-p"
        v-for="item in safetyTypes"
        :key="item.id"
      >
        <safety-type-block
          :id="item.id"
          :name="item.name"
          :photo="item.photo"
          :short-description="item.short_description"
          :description="item.description"
          :checked="isItemChecked('safety.id', item.id)"
          @click="handleItemClick(item)"
        />
      </div>
    </div>
  </step-section>
</template>

<script>
  import SafetyTypeBlock from '@/components/blocks/SafetyTypeBlock.vue';
  import stepMixin from './stepMixin';

  export default {
    name: 'SafetyStep',
    mixins: [stepMixin],
    props: {
      safetyTypes: Array,
    },
    methods: {
      handleItemClick(safety) {
        this.updateFormField({
          field: 'safety',
          value: {
            id: safety.id,
            name: safety.name,
          },
        });
      },
    },
    components: {
      SafetyTypeBlock,
    },
  };
</script>
